// Header status-tag composer. Mounted from `transactionConfig.view.statusPills`.
// Composes the canonical EnumTags + DprChip so the header chips read from one place.
// Pure props in, JSX out. No data fetches.

import React from "react";
import { useTranslation } from "react-i18next";
import type { Transaction } from "@shared/types/transaction";
import { BorderTypeChip } from "@ds/domain/BorderTypeChip";
import { GdStatusChip } from "@ds/domain/GdStatusChip";
import { DprChip } from "@ds/domain/DprChip";
import { Inline } from "@ds/layout/Inline";

export interface TransactionStatusPillsProps {
  transaction: Transaction;
}

export const TransactionStatusPills: React.FC<TransactionStatusPillsProps> = ({
  transaction: tx,
}) => {
  useTranslation();

  // Lifecycle tag removed from header — it read as a duplicate of the
  // checklist progress band underneath and cluttered the header for the
  // common (in-flight) case.
  const showBorder = tx.border_type && tx.border_type !== "domestic";
  const showDpr    = tx.request_dpr === true;
  const showGd     = tx.gd_status === "yes" || tx.gd_status === "no";

  if (!showBorder && !showDpr && !showGd) return null;

  return (
    <Inline as="span" inline gap="xs" wrap>
      {showBorder && <BorderTypeChip value={tx.border_type} size="sm" />}
      {showDpr    && <DprChip active={tx.request_dpr} size="sm" />}
      {showGd     && <GdStatusChip status={tx.gd_status ?? undefined} size="sm" />}
    </Inline>
  );
};

